import type HttpClient from "../../tastyworks/http"
import {
  JOURNAL_ENTRY_DESER,
  JournalEntry,
} from "../../tastyworks/journal-entry"
import type { Params } from "../../tastyworks/request"
import type { ItemsResponse } from "../../tastyworks/response"

export class JournalEntryService {
  constructor(private readonly baseHttpClient: HttpClient) {}

  readonly index = async (
    params?: Params
  ): Promise<ItemsResponse<JournalEntry>> =>
    this.baseHttpClient.indexSimple(
      JOURNAL_ENTRY_DESER.toParser(JournalEntry),
      "/journal-entries",
      params
    )
}
